import { takeLatest } from 'redux-saga'
import { call, select } from 'redux-saga/effects'
import actionTypes from 'redux/actions/actionTypes'
import { mediaSearchSync } from 'sync'
import { studentSelectors } from 'redux/selectors'

function *getSearchHeaders() {
	const studentSessionData = yield select(studentSelectors.studentSessionDataSelector)
	return studentSessionData.headers || {}
}

function *mediaSearchGetResults(action) {

	try {
		let response
		switch (action.searchType) {
			case 'image':
				const searchHeaders = yield call(getSearchHeaders)
				if (action.source === 'google') {
					response = yield call(mediaSearchSync.searchGoogleImages, action.value, action.page, searchHeaders)
				} else if (action.source === 'bing') {
					response = yield call(mediaSearchSync.searchBingImages, action.value, action.page, action.allowSearchMore, searchHeaders)
				}
				break
			case 'gif':
				response = yield call(mediaSearchSync.searchGoogleGifs, action.value, action.page, action.allowSearchMore)
				break
			case 'video':
				if (action.source === 'youtube') {
					response = yield call(mediaSearchSync.searchYoutubeVideos, action.value, action.page)
				}
				break
		}
		action.resolve(response)
	} catch (error) {
		action.reject(error)
	}
}

export default [
	takeLatest(actionTypes.MEDIA_SEARCH_GET_RESULTS, mediaSearchGetResults),
]
